import { Trophy, Rocket } from "lucide-react";

const ArticleDifference = () => {
  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 backdrop-blur-sm">
            <Trophy className="w-4 h-4 text-blue-400" />
            <span className="text-sm font-semibold text-blue-400 tracking-wide uppercase">
              Why We Stand Out
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 mt-12">
            What Makes This{" "}
            <span className="text-transparent bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text">
              Cohort Different?
            </span>
          </h2>

          <p className="text-gray-400 text-lg max-w-2xl mx-auto md:whitespace-nowrap">
            Learning designed to fit your needs.
          </p>
        </div>

        {/* Features */}
        <div className="space-y-8">
          {/* Live Interactive Sessions */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 to-gray-800 border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-8">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                  <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
                </div>
                <h3 className="text-xl text-left font-bold text-white  group-hover:text-blue-300 transition-colors">
                  Live Interactive Sessions
                </h3>
              </div>

              <p className="text-gray-300 text-left leading-relaxed group-hover:text-white transition-colors duration-300">
                Ask, discuss, and get feedback in real-time.{" "}
                <span className="text-blue-300 font-semibold">
                  No pre-recorded videos, no delayed responses.
                </span>
              </p>
            </div>
          </div>

          {/* Expert Instructors */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 to-gray-800 border border-gray-700 hover:border-indigo-500/50 transition-all duration-300">
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-8">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-indigo-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl text-left font-bold text-white  group-hover:text-indigo-300 transition-colors">
                  Expert Instructors
                </h3>
              </div>

              <p className="text-gray-300 text-left leading-relaxed group-hover:text-white transition-colors duration-300">
                Learn from mentors like Vaishnavi and top industry professionals
                with{" "}
                <span className="text-purple-300 font-semibold">
                  real-world experience.
                </span>
              </p>
            </div>
          </div>

          {/* Community Vibes */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 to-gray-800 border border-gray-700 hover:border-purple-500/50 transition-all duration-300">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-8">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-purple-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl text-left font-bold text-white  group-hover:text-purple-300 transition-colors">
                  Community Vibes
                </h3>
              </div>

              <p className="text-gray-300 text-left leading-relaxed group-hover:text-white transition-colors duration-300">
                Be part of a close-knit batch eager to learn and grow together.{" "}
                <span className="text-emerald-300 font-semibold">
                  {" "}
                  Build lifelong connections.
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center mt-12">
          <p className="text-gray-400">
            Meticulously structured to guide your -{" "}
            <span className="text-white font-semibold">ArticleShip path</span>
          </p>
        </div>

        <div className="mt-12 text-center">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-black to-blue-950 border border-blue-500/20 p-6 md:p-8 mb-8">
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -mr-32 -mt-32" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl -ml-32 -mb-32" />

            {/* HR quote background */}
            <div className="absolute inset-0 flex items-center justify-center opacity-5">
              <div className="font-sans text-purple-400/30 text-sm">
                {"People are our greatest asset"}
              </div>
            </div>

            <div className="relative z-10 flex flex-col items-center gap-4">
              <div className="flex flex-col md:flex-row items-center gap-3">
                <Rocket className="w-6 h-6 text-blue-400 animate-bounce" />
                <p className="text-lg md:text-xl font-medium text-purple-100 text-center md:text-left">
                  Register for the{" "}
                  <span className="font-sans text-green-400">
                    Article Ship Cohort
                  </span>{" "}
                  —where your articleship dreams set sail.
                </p>
              </div>
              <div className="px-4 py-2 bg-gray-800/50 rounded-lg font-sans text-sm text-gray-400 border border-gray-700">
                Master Essential CA Articleship Skills in Weeks
              </div>
            </div>
          </div>

          <button
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-bold rounded-lg shadow-lg hover:shadow-blue-600/20 transition-all duration-300 hover:scale-105 relative group"
            onClick={() => window.open("https://forms.gle/MJKFPg6sL45LE4bP8")}
          >
            <span className="relative z-10">Register Now</span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleDifference;
